/**
 * In produzione disattiva log/info/debug/warn nella console del browser.
 * console.error resta per React e librerie; gli errori applicativi usano devConsole.devError.
 */
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
  // eslint-disable-next-line no-console
  console.warn = noop;
}
